/** Accent colours per fighter slot: distinct hues, readable on the bone-white body. */
export const ACCENTS = [
  "#ffa42b",
  "#4cc9f0",
  "#ff5c8a",
  "#3ddc84",
  "#c77dff",
  "#ffd166",
  "#ff7a45",
  "#5ce1e6",
  "#f15bb5",
  "#9ef01a",
  "#ff9e00",
  "#00bbf9",
  "#e63946",
  "#80ed99",
  "#b5179e",
  "#fee440",
  "#4895ef",
  "#ff477e",
  "#06d6a0",
  "#f3722c",
] as const;

export function accentFor(id: number): string {
  return ACCENTS[id % ACCENTS.length] ?? "#ffffff";
}
